<template>
  <div>
    <section id="content" class="section-report">
      <div v-for="(v, k) in data" :key="k">
        <!-- Header Title -->
        <div
          style="margin-bottom: 40px"
          v-if="v.first === 'RGO-02-TOTAL FRP INTRALABORALES'"
        >
          <CardTitle :frsm="frsm" />
          <br />
          <h1 class="is-size-4 has-text-weight-bold" style="color: #9641CC;">
            Responsable
          </h1>
          <div class="box">
            <div class="columns">
              <div class="column has-text-centered">
                <h1>
                  <strong>Maria Eugenia Londoño Londoño</strong>
                </h1>
              </div>
              <div class="column has-text-centered">
                <h3>
                  <strong>Psicóloga - Licencia en SST. Resolución</strong>
                </h3>
              </div>
              <div class="column has-text-centered">
                <span>S2023060046215</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Header of Board -->
        <nav class="level" style="margin-bottom: 4%; margin-top: 4%">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Fecha del Diagnóstico</p>
              <p class="title">{{ header.date }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Encuestados</p>
              <p class="title">{{ header.surveyed }}</p>
            </div>
          </div>
        </nav>

        <!-- Header for Engagement -->
        <br v-if="v.first === 'RGO-02-TOTAL FRP INTRALABORALES'" />
        <div v-if="v.first === 'RGO-02-TOTAL FRP INTRALABORALES'" class="box">
          <div class="columns has-text-centered">
            <div class="column is-one-third">
              <span class="heading has-text-weight-bold"
                >Prioridad de intervención</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr class="bg-alta">
                    Alta
                  </tr>
                  <tr class="bg-media">
                    Media
                  </tr>
                  <tr class="bg-destacado">
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de riesgo</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-2">
                  <tr class="bg-muyAlto">
                    Muy alto
                  </tr>
                  <tr class="bg-alto">
                    Alto
                  </tr>
                  <tr class="bg-media">
                    Media
                  </tr>
                  <tr class="bg-bajo">
                    Bajo
                  </tr>
                  <tr class="bg-noRiesgo">
                    Sin riesgo...
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br v-if="v.first === 'RGO-02-TOTAL FRP INTRALABORALES'" />
        <!-- Header for Engagement -->
        <br v-if="v.first === 'RGO-09-Engagement'" />
        <div class="box" v-if="v.first === 'RGO-09-Engagement'">
          <!-- Part Header of Quadrants - Engagement -->
          <div class="columns has-text-centered">
            <div class="column is-one-third">
              <span class="heading has-text-weight-bold"
                >Prioridad de intervención</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr class="bg-alta">
                    Alta
                  </tr>
                  <tr class="bg-media">
                    Media
                  </tr>
                  <tr class="bg-destacado">
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de efecto</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-2">
                  <tr class="bg-muyAltoEng">
                    Muy alto
                  </tr>
                  <tr class="bg-altoEng">
                    Alto
                  </tr>
                  <tr class="bg-media">
                    Medio
                  </tr>
                  <tr class="bg-bajoEng">
                    Bajo
                  </tr>
                  <tr class="bg-noRiesgoEng">
                    Muy bajo
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <ContentReportFRP
          :data="getDataInter(frsm.dataAdmin[v.first], v.title)"
        />
        <br class="breakPage" />
        <!-- Sub-Items -->
        <article v-if="v.sub2" class="message">
          <div v-for="(sv, sk) in v.sub2" :key="sk" class="message-body">
            <ContentReportFRP
              :data="getDataInter(frsm.dataAdmin[sv.first], sv.title)"
            />
            <br class="breakPage" />
            <!-- Items -->
            <article v-if="sv.sub" class="message">
              <div v-for="(ssv, ssk) in sv.sub" :key="ssk" class="message-body">
                <ContentReportFRP
                  :data="getDataInter(frsm.dataAdmin[ssv.first], ssv.title)"
                />
                <br class="breakPage" />
              </div>
            </article>
          </div>
        </article>
        <br />
        <!-- Items -->
        <article v-if="v.sub" class="message">
          <div v-for="(sv, sk) in v.sub" :key="sk" class="message-body">
            <ContentReportFRP
              :data="getDataInter(frsm.dataAdmin[sv.first], sv.title)"
            />
            <br class="breakPage" />
          </div>
        </article>
        <br />
      </div>
      <CardProfessional :img="true" :logo="true" />
    </section>
  </div>
</template>
<script>
import ContentReportFRP from "./components/frp/ContentReportFRP.vue";
import CardTitle from "./components/frp/CardTitle.vue";
import CardProfessional from "./components/frp/CardProfessional.vue";

export default {
  name: "ReportFRP",
  data() {
    return {};
  },
  props: {
    frsm: {
      type: Object,
      required: true,
    },
    header: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getDataInter(data, title) {
      return {
        data,
        title,
        group: data[0].Grupo,
      };
    },
  },
  components: {
    CardTitle,
    ContentReportFRP,
    CardProfessional,
  },
};
</script>
<style lang="scss" scoped>
.message {
  background-color: #ffffff;
}
>
  // Range 1
.bg-muyAlto {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-alto {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-bajo {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-noRiesgo {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
// Range 1.1
.bg-muyAltoEng {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
.bg-altoEng {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-bajoEng {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-noRiesgoEng {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
// Range 2
.bg-alta {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-media {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacado {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrango {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
// Color icons
.bg-alta .icon-dash {
  background-color: #f6adad;
  border-radius: 50%;
}
.bg-media .icon-dash {
  background-color: #f6db8a;
  border-radius: 50%;
}
.bg-destacado .icon-dash {
  background-color: #c3eab5;
  border-radius: 50%;
}
.bg-sinrango .icon-dash {
  background-color: #d4d5d3;
  border-radius: 50%;
}
// Table
#table-1 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-2 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-1 tr {
  width: 100% !important;
  text-align: center !important;
}
#table-2 tr {
  width: 100% !important;
  text-align: center !important;
}

.section-report {
  width: 100% !important;
  padding: 80px !important;
}

.has-text-weight-bold {
  font-weight: 700 !important;
}

.is-size-4 {
  font-size: 1.5rem !important;
}

.has-text-centered {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ReportFRP.vue